module.exports = __webpack_public_path__ + "img/calendar_check_hoso.2f7c9458.svg";